/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import {
  BookmarkIcon,
  Button,
  Flex,
  SearchIcon,
  Text,
} from '@bottlebooks/gatsby-theme-base';
import { useFavorites } from '@bottlebooks/gatsby-plugin-bookmarks/src';
// import LanguageSwitcher from './LanguageSwitcher';
import MultisiteSwitcher from '@bottlebooks/gatsby-theme-event/src/components/Layout/MultisiteSwitcher';
import TopMenuItems from '@bottlebooks/gatsby-theme-event/src/components/Layout/TopMenuItems';
import { ShoppingCartIndicator } from '@bottlebooks/gatsby-theme-event/src/components/Shop/ShoppingCartMenu';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';

export default function MenuActions({
  searchIsVisible = false,
  toggleSearchIsVisible = (state) => {},
  ...rest
}) {
  const { favorites: bookmarks } = useFavorites();
  const link = useLink();
  return (
    <Flex
      gap={2}
      align="center"
      justify="flex-end"
      sx={{ flexGrow: 1 }}
      {...rest}
    >
      <TopMenuItems />
      {/* <LanguageSwitcher /> */}

      <MultisiteSwitcher sx={{ display: ['none', null, 'flex'] }} />

      <Button
        to={link.bookmarks()}
        variant="text"
        sx={{
          position: 'relative',
          paddingX: 1,
          paddingY: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Text variant="small">
          <Trans>My list</Trans>
        </Text>
        <BookmarkIcon
          variant={bookmarks?.length ? 'inverted' : 'hollow'}
          sx={{
            color: bookmarks?.length ? 'primary' : null,
            height: 25,
            width: 25,
            marginLeft: 1,
          }}
        />

        {Boolean(bookmarks?.length) && (
          <Text
            variant="small"
            sx={{
              position: 'absolute',
              right: -2,
              top: -2,
              color: 'primary',
            }}
          >
            {bookmarks?.length}
          </Text>
        )}
      </Button>
      <Button
        variant="text"
        onClick={() => toggleSearchIsVisible(!searchIsVisible)}
        sx={{ padding: 1, display: ['flex', null, 'none'] }}
      >
        <SearchIcon size="small" />
      </Button>
      {process.env.GATSBY_SNIPCART_API_KEY && <ShoppingCartIndicator />}
    </Flex>
  );
}
